module.exports = __webpack_public_path__ + "431f332b59968868976e83554d2eb529.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/sample/signature.png
// module id = 650
// module chunks = 0